var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "FormGroup",
    {
      attrs: {
        "error-container": _vm.errorContainer,
        label: "Residential Status",
        name: "residentialStatus",
        floating: _vm.floating,
      },
    },
    [
      _c("FmSelect", {
        attrs: {
          value: _vm.value,
          options: _vm.options,
          icons: _vm.icons,
          disabled: _vm.disabled,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }